import { useCallback } from 'react';

import { useLocalStorage } from '@uidotdev/usehooks';

function isLocalStorageAvailable(): boolean {
  try {
    const test = '__test__';
    localStorage.setItem(test, test);
    localStorage.removeItem(test);
    return true;
  } catch {
    return false;
  }
}

/**
 * localStorage hook that no-ops when storage is unavailable (private mode, quota).
 */
export function useSafeLocalStorage<T>(key: string, defaultValue: T): [T, (value: T) => void] {
  const [value, setValue] = useLocalStorage(key, defaultValue);

  const safeSetValue = useCallback(
    (newValue: T) => {
      try {
        if (isLocalStorageAvailable()) {
          setValue(newValue);
        }
      } catch (error) {
        console.warn(`Failed to set ${key} in localStorage:`, error);
      }
    },
    [key, setValue],
  );

  return [value, safeSetValue];
}
